import { Utils } from 'versafleet-core';

const { ReduxHelper } = Utils;

const initialState = {
  customFieldGroups: {},
  customFieldGroupIds: [],
  isLoading: false,
  isLoadingItem: false,
  optionCustomFieldGroups: [],
  selectedId: null,
  customFieldDescriptions: {},
};

function customFieldGroup(state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_CUSTOM_FIELD_GROUP':
      return {
        ...state,
        isLoadingItem: true,
      };
    case 'RECEIVE_CUSTOM_FIELD_GROUP':
      return {
        ...state,
        isLoadingItem: false,
        selectedId: action.customFieldGroup.id,
        customFieldGroups: ReduxHelper.mergeDataWithObject(
          state.customFieldGroups, action.customFieldGroup,
        ),
      };
    case 'REQUEST_CUSTOM_FIELD_GROUPS':
      return {
        ...state,
        isLoading: true,
      };
    case 'RECEIVE_CUSTOM_FIELD_GROUPS':
      return {
        ...state,
        isLoading: false,
        customFieldGroupIds: action.customFieldGroups.map(
          _customFieldGroup => _customFieldGroup.id,
        ),
        customFieldGroups: ReduxHelper.mergeDataWithList(
          state.customFieldGroups, action.customFieldGroups,
        ),
      };
    case 'RECEIVE_OPTION_CUSTOM_FIELD_GROUPS':
      return {
        ...state,
        optionCustomFieldGroups: action.customFieldGroups,
      };
    case 'RECEIVE_CUSTOM_FIELD_DESCRIPTION':
      return {
        ...state,
        customFieldDescriptions: ReduxHelper.mergeDataWithObject(
          state.customFieldDescriptions, action.customFieldDescription,
        ),
      };
    default:
      return state;
  }
}

export default customFieldGroup;
